import * as CardApplication from '@/src/experiences/card-application'

export default CardApplication.Components.withCardPlatform(
  CardApplication.Screens.DocumentUploadScreen,
  CardApplication.Screens.Highnote.DocumentUpload,
)
